import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

export default function MarcasConfian({ marcas, titulo }) {
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <section className="w-full bg-sidom-blue flex flex-col items-center justify-center">
      <div className="container mt-[70px] md:mt-[100px] lg:mt-[90px]  ">
        {titulo && (
          <h1 className="text-left w-full text-xl sm:text-2xl md:text-3xl lg:text-4x1 leading-6 font-bold text-sidom-orange mb-11">
            {titulo}
          </h1>
        )}
        <Swiper
          spaceBetween={1}
          slidesPerView={marcas?.length < 3 ? marcas.length : 3}
          centeredSlides={marcas?.length < 3}
          loop={marcas?.length >= 3} // Desactiva el loop si hay pocas imágenes
          speed={7000}
          autoplay={{
            delay: 1,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
            400: { slidesPerView: 3, spaceBetween: 10 },
            640: { slidesPerView: 4, spaceBetween: 10 },
            1024: { slidesPerView: 8, spaceBetween: 10 },
          }}
          className={`w-full flex ${
            marcas?.length < 3 ? "justify-center" : "justify-start"
          } items-center mb-[70px] md:mb-[100px] lg:mb-[90px]`}
        >
          {marcas?.map((marca, idx) => (
            <SwiperSlide key={idx} className="flex justify-center items-center">
              <img
                src={`${urlApi}${marca.formats?.thumbnail?.url || marca.url}`}
                alt={marca.alt}
                className="max-h-16 md:max-h-20 max-w-[120px] object-contain"
                loading="lazy"
                draggable={false}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
